module.exports = __webpack_public_path__ + "img/accusoft.736850ad.svg";